export const STORAGE_LIMIT_REACHED_MESSAGE =
    'This client has reached its storage limit. Please contact your client administrator for assistance.';

export const RPL_TOKEN_LIMIT_REACHED_MESSAGE =
    'All RPL tokens for this client have been used. Please contact your client administrator for assistance.';

export const TRIAL_INVITE_LIMIT_REACHED_MESSAGE =
    'Trial invitation limit reached. You have used all available candidate invitation slots for your current RPL token allocation.';

export const NO_SUBSCRIPTION_MESSAGE =
    'This deployment does not have an active subscription yet. Please contact your administrator to set up or activate your subscription.';

export const COURSE_REQUIRED_BEFORE_INVITE_MESSAGE = 'A course must be created before inviting a candidate.';

export const CANCELLED_INVITATION_ERROR_CODE = 'candidate_invitation_cancelled';

export const CANCELLED_INVITATION_ERROR_MESSAGE =
    'This RPL invitation has been cancelled and is no longer available. Please contact your client administrator for assistance.';
